import styled from 'styled-components'

export const Wrapper = styled.div`
  min-height: 115px;
  max-width: 324px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 10px;
  padding: 16px;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    span {
      text-overflow: initial;
      max-width: auto;
      white-space: normal;
    }
  }
`

export const File = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`

export const FileIcon = styled.img`
  height: 40px;
  background-color: #feefef;
  padding: 4px;
  border-radius: 8px;
`

export const FileName = styled.span`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray};
  margin-left: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 170px;
`

export const UploadAt = styled.span`
  display: inline-block;
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  color: ${({ theme }) => theme.colors.lightGray};
`

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;

  button + button {
    margin-left: 8px;
  }

  button {
    background-color: ${({ theme }) => theme.colors.white};
    border: 0;
    display: flex;
    align-items: center;
    padding: 4px;

    svg {
      margin-right: 6px;
    }

    label {
      font-size: ${({ theme }) => theme.font.sizes.small};
      color: ${({ theme }) => theme.colors.lightGray};
      cursor: pointer;
    }
  }
`
